import _ from 'underscore';
import type {
  EntityObject,
} from '../public-types';
import type { RequestContract } from '../spec';
import type { Store } from '../store';
import { getRecordGroup } from '../store';
import type { LookupCacheFn } from './helper';

interface CacheLookupOptions<TEntity extends EntityObject, TVariables extends object> {
  store: Store<TEntity>;
  requestContract: RequestContract<TVariables>;
  variables: TVariables;
  lookupFn: LookupCacheFn<TEntity, TVariables>;
}

export function getCacheIds<TEntity extends EntityObject, TVariables extends object>({
  store,
  requestContract,
  variables,
  lookupFn,
}: CacheLookupOptions<TEntity, TVariables>) {
  const records = getRecordGroup(store, requestContract)?.records || [];
  const cacheRawItems = _.map(records, record => record.data);
  const cacheHit = lookupFn(cacheRawItems, variables);
  return _.chain(_.flatten([cacheHit], true))
    .map(data => _.find(records, record => record.data === data)?.id)
    .compact()
    .value() as string[];
}
